import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/css';
import { useTheme } from '@emotion/react';

const ReadingItem = ({ reading }) => {
    const theme = useTheme();
    return (
        <div
            className={css`
                font-size: 18px;
                color: ${theme.colours.darkGray};
                line-height: 1.5;
            `}
        >
            {reading.replace('@', '').replace(/~/g, '; ')}
        </div>
    );
};
ReadingItem.propTypes = {
    reading: PropTypes.string.isRequired,
};

export default ReadingItem;
